import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Injector,
  inject,
} from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { EventManager, AccountService } from "src/app/core";
import { ProductService } from "../../product.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { UsersService } from "src/app/modules/users/users.service";
import { QueryParams } from "src/app/shared/model/query.params.model";
import { FormBuilder, Validators } from "@angular/forms";
import { EditPageComponent } from "../../../../shared/components/edit.page.component";
import { ModalComponent } from "../../../../shared/components/modal.component";

@Component({
  selector: "app-create-product",
  templateUrl: "./create-product.component.html",
  styleUrls: ["./create-product.component.scss"],
})
export class CreateProductComponent extends ModalComponent implements OnInit {
  editForm = this.fb.group({
    name: ["", [Validators.required]],
    productOwnerId: [null, [Validators.required]],
    programName: ["", [Validators.required]],
  });
  issuers: any[] = [];
  typeCode: any = '';
  typeName: any = '';
  issuerId: any = '';
  constructor(
    public modalRef: NzModalRef,
    private fb: FormBuilder,
    public eventManager: EventManager,
    public router: Router,
    public route: ActivatedRoute,
    private productService: ProductService,
    public usersService: UsersService,
    private toastService: ToastrService,
  ) {
    super(eventManager, modalRef);
  }

  ngOnInit(): void {
    super.ngOnInit();
    const params = this.route.snapshot.params;
    this.typeCode = params.typeCode || this.typeCode;
    switch (this.typeCode) {
      case "PROTECTION":
        this.typeName = "Bảo hiểm tử kỳ";
        break;
      case "UNIVERSAL_LIFE":
        this.typeName = "Liên kết chung";
        break;
      case "UNIT_LINKED":
        this.typeName = "Liên kết đơn vị";
        break;
      case "PROTECTION_FOCUS":
        this.typeName = "Bảo hiểm hỗn hợp";
        break;
    }
    const queryParams = this.route.snapshot.queryParams;
    this.issuerId = queryParams.issuerId ? parseInt(queryParams.issuerId) : this.issuerId || null;
    if (this.issuerId) {
      this.editForm.patchValue({
        productOwnerId: this.issuerId,
      });
    }
    this.loadIssuer();
  }
  loadIssuer() {
    const queryParams = new QueryParams();
    queryParams.size = 100;
    this.usersService.queryIssuers(queryParams).subscribe((res: any) => {
      this.issuers = (res.data || []).filter((item) => !item.isDisable);
    });
  }
  save() {
    this.isSaved = true;
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return;
    }
    const body = {
      productOwnerId: this.editForm.get("productOwnerId").value,
      name: (this.editForm.get("name").value || "").trim(), //"Bảo hiểm test"
      typeCode: this.typeCode,
      programName: (this.editForm.get("programName").value || "").trim(),
    };
    if (this.isCalling) {
      return;
    }
    this.isCalling = true;
    return this.productService.create(body).subscribe(
      (res: any) => {
        this.toastService.success("Tạo sản phẩm thành công");
        const product = res.body.data || {};
        this.router.navigate(["/products/detail/" + product.id]);
        this.cancel();
      },
      (err) => {
        this.isCalling = false;
      },
    );
  }
  cancel() {
    this.modalRef.close();
  }
}
